import {
	_NEVER,
	BaseQueryFn,
	createApi,
	EndpointBuilder,
	fakeBaseQuery
} from "@reduxjs/toolkit/query/react"
import { ApiTag } from "./util/ApiTag"
import auditEndpoints from "./Audit.Query"
import bridgeEndpoints from "./Bridge.Query"
import templateEndpoints from "./Template.Query"
import ssoEndpoints from "./Sso.Query"
import spireIntegrationEndpoints from "./Integrations.Spire.Query"
import phinEndpoints from "./Phin.Query"
import patientConditionIssuesEndpoints from "./PatientCondition.Issues.Query"
import medicalHierarchyEndpoints from "./MedicalHierarchy.Query"
import patientEndpoints from "./Patient.Query"
import patientConditionEndpoints from "./PatientCondition.Query"
import eventLogEndpoints from "./EventLog.Query"
import professionalEndpoints from "./Professional.Query"
import userEndpoints from "./User.Query"
import genesisCareIntegrationEndpoints from "../Integrations.GenesisCare.Query"

export type McoEndpointBuilder = EndpointBuilder<
	BaseQueryFn<void, typeof _NEVER, unknown, {}, {}>,
	ApiTag,
	"api"
>

const apiSlice = createApi({
	reducerPath: "api",
	baseQuery: fakeBaseQuery(),
	endpoints: () => ({}),
	tagTypes: Object.values(ApiTag)
})
	.injectEndpoints({
		endpoints: auditEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: bridgeEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: eventLogEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: medicalHierarchyEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: patientConditionEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: patientEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: patientConditionIssuesEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: phinEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: professionalEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: ssoEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: genesisCareIntegrationEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: spireIntegrationEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: templateEndpoints,
		overrideExisting: false
	})
	.injectEndpoints({
		endpoints: userEndpoints,
		overrideExisting: false
	})

export default apiSlice
